import styled from 'styled-components';
import colors from 'constants/colors';

export const VersionCheckerContainer = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 16px;
  background-color: ${colors.lightGreen};
  padding: 10px;
  z-index: 2500;

  .text {
    font-size: 16px;
    font-weight: bold;
  }

  button {
    height: 36px;
    font-size: 13px;
    font-weight: bold;
    color: ${colors.white};
  }
`;